<!--  -->
<template>
  <div>
    <div
      class="MyLoadSuccessList"
      @click="
        () => {
          loanRecords(e)
        }
      "
      v-for="(e) in resultList.loanSupermarketDrawVoList"
      :key="e.drawId"
    >
      <div class="MyLoadList_head">
        <img :src="resultList.pcLogoUrl" alt="" />
        <div>{{ e.productName }}</div>
      </div>
      <div class="MyLoadList_line"></div>
      <div class="MyLoadList_content">
        <div>
          <div class="MyLoadList_content_title">申请金额(元)</div>
          <div class="MyLoadList_content_text">{{ e.drawAmt !== 'null' ? e.drawAmt : '--'}}</div>
        </div>
        <div>
          <div class="MyLoadList_content_title">贷款期限</div>
          <div class="MyLoadList_content_text">{{ (e.term && e.term !== '0') ? e.term + '个月' : '--' }}</div>
        </div>
        <div>
          <div class="MyLoadList_content_title">提款日期</div>
          <div class="MyLoadList_content_text">{{ e.drawTime }}</div>
        </div>
        <div>
          <div class="MyLoadList_content_title">状态</div>
          <div class="MyLoadList_content_text">
            {{ creditSuccessListStr[e.debtStatus] || '--' }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'MyLoadSuccessList',
  data() {
    return {
      creditSuccessListStr: {
        0: '正常',
        1: '逾期',
        2: '结清',
      },
      resultList: [],
    };
  },
  props: ['list'],
  watch: {
    list: {
      handler(val) {
        console.log(val, 'val');
        this.resultList = val;
      },
      immediate: true,
      deep: true,
    },
  },
  computed: {
    debtStatus(e) {
      return this.creditSuccessListStr(e.debtStatus);
    },
  },
  mounted() {},
  methods: {
    loanRecords(e) {
      this.$api.PublicPage.jumpRepayUrl({
        orderId: this.list.orderId,
        drawId: e.drawId,
      })
        .then((res) => {
          if (res.success) {
            console.log(res.data);
            window.location.href = res.data;
          } else {
            this.$dialog.alert({
              title: '提示',
              message: '操作失败',
            });
          }
        })
        .catch((error) => {
          this.$dialog.alert({
            title: '提示',
            message: error,
          });
        });
    },
  },
};
</script>
<style scoped>
.MyLoadSuccessList {
  height: 129px;
  background: #fff;
  display: flex;
  flex-direction: column;
  justify-content: center;
  justify-items: center;
  margin-top: 10px;
}
.MyLoadList_head img {
  width: 25px;
  height: 25px;
  border-radius: 50%;
  margin: 0 8px;
  border: 1px solid #ececec;
}
.MyLoadList_head {
  display: flex;
  justify-content: left;
  align-items: center;
  margin-bottom: 8px;
  font-size: 14px;
  font-weight: bold;
}
.MyLoadList_line {
  width: 100%;
  height: 1px;
  background: #eee;
}
.MyLoadList_content {
  width: 100%;
  height: 73px;
  display: flex;
  justify-content: space-around;
  align-items: center;
}
.MyLoadList_content_title {
  font-size: 12px;
  color: #b7bfd2;
}
.MyLoadList_content_text {
  font-size: 13px;
  color: #000;
  margin-top: 8px;
}
</style>
